import isEqual from 'lodash/isEqual'
import * as React from 'react'

import { ITabOption } from 'main/util/tab'
import { Container, Tab } from './TabGroup.styles'

interface IProps<T> {
  full?: boolean
  outline?: boolean
  options: Array<ITabOption<T>>
  value: T
  onChange: (value: T) => void
}

export default function TabGroup<T>(props: IProps<T>) {
  const { full, outline, options, value, onChange } = props

  return (
    <Container full={full} outline={outline}>
      {options.map((option, index) => (
        <Tab
          key={index}
          active={isEqual(option.value, value)}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Tab>
      ))}
    </Container>
  )
}
